export enum UserType {
  Internal = 'INTERNAL',
  Expert = 'EXPERT',
  Company = 'COMPANY'
}
